import Esia from './Esia.vue';
export default Esia;



// WEBPACK FOOTER //
// ./src/components/esialink/index.ts